import { Button, cn, ModeToggle, Skeleton } from "@devhop/ui";
import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { usePublishedCatalogQuery } from "../api/queries";

export function PublicEventsPage() {
  const { data: catalog, isPending } = usePublishedCatalogQuery();

  return (
    <div className="flex min-h-svh flex-col bg-background">
      <header className="kpop-bg border-border border-b bg-card px-4 py-4 sm:px-6">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-3">
          <div>
            <p className="font-bold text-accent text-xs uppercase tracking-widest">
              KiDS EXPO 2026
            </p>
            <h1 className="kpop-gradient-text font-extrabold text-2xl leading-tight">
              ຜົນການແຂ່ງຂັນ
            </h1>
            <p className="mt-1 text-muted-foreground text-sm">
              ເລືອກງານທີ່ຜົນໄດ້ເປີດສາທາລະນະເພື່ອເບິ່ງລະດັບ
            </p>
          </div>
          <ModeToggle />
        </div>
      </header>

      <main className="mx-auto flex w-full max-w-3xl flex-1 flex-col gap-4 p-6">
        <div className="flex flex-wrap gap-3">
          <div className="flex flex-col gap-1.5">
            <Link to="/competition/login">
              <Button variant="outline" size="sm">
                ເຂົ້າລະບົບຜູ້ຄຸ້ມຄອງ
              </Button>
            </Link>
            <p className="max-w-xs text-muted-foreground text-xs leading-snug">
              ກຳມະການໃຊ້ລິ້ງສ່ວນຕົວຈາກຜູ້ຈັດງານ — ບໍ່ໃຊ້ໜ້ານີ້
            </p>
          </div>
        </div>

        {isPending ? (
          <div className="flex flex-col gap-3">
            {Array.from({ length: 5 }).map((_, i) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: skeleton
              <Skeleton key={i} className="h-24 w-full rounded-2xl" />
            ))}
          </div>
        ) : !catalog?.length ? (
          <div className="flex flex-col items-center justify-center rounded-2xl bg-card py-20 text-center ring-1 ring-border">
            <p className="font-semibold text-foreground text-lg">ຍັງບໍ່ມີຜົນປະກາດ</p>
            <p className="mt-2 max-w-sm px-4 text-muted-foreground text-sm">
              ລໍຖ້າຜູ້ຈັດງານປະກາດຜົນ — ຫຼັງປະກາດແລ້ວຈະສະແດງລາຍກຳຂອງງານນັ້ນບ່ອນນີ້
            </p>
          </div>
        ) : (
          <ul className="flex flex-col gap-2">
            {catalog.map((ev) => (
              <li key={ev.id}>
                <Link
                  to="/competition/events/$eventId/results"
                  params={{ eventId: ev.id }}
                  className={cn(
                    "flex min-w-0 items-center gap-4 rounded-2xl bg-card p-4 ring-1 ring-border",
                    "transition-shadow hover:bg-muted/30 hover:shadow-md",
                  )}
                >
                  <div className="min-w-0 flex-1">
                    <span className="truncate font-semibold text-foreground">
                      {ev.name}
                    </span>
                    <p className="mt-1 truncate font-mono text-muted-foreground text-xs">
                      {ev.slug}
                    </p>
                  </div>
                  <ChevronRight className="size-5 shrink-0 text-muted-foreground" />
                </Link>
              </li>
            ))}
          </ul>
        )}
      </main>

      <footer className="border-border border-t px-4 py-3 text-center text-muted-foreground text-xs">
        KiDS EXPO 2026 — K-POP Cover Dance Open Division
      </footer>
    </div>
  );
}
